import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

export const availableLocales = {
  da: 'da_DK',
  de: 'de_DE',
  es: 'es_ES',
  fr: 'fr_FR',
  lt: 'lt',
  nl: 'nl_NL',
  pt: 'pt_PT',
  sv: 'sv_SE',
  ca: 'es_ES',
  eu: 'es_ES',
  gl: 'es_ES',
}
const receivedLocale = window.marketgoo?.locale || 'en_US'

export const [currentLocale] = receivedLocale.split('_')

const translationFile = availableLocales[currentLocale] || 'en_US'

const resource = require(`./${translationFile}.json`)
const fallbackResource = require(`./en_US.json`)

i18next.use(initReactI18next).init({
  lng: currentLocale,
  resources: {
    [currentLocale]: {
      translation: resource,
    },
    en: {
      translation: fallbackResource,
    },
  },
  fallbackLng: 'en',
})

export default i18next
